import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose, withHandlers } from 'recompose';
import { USER_TYPES } from '../../../auth/constants';
import withActiveType from '../../../auth/utils/withActiveType';
import withRole from '../../../auth/utils/withRole';

import withToggle from '../../../common/hoc/withToggle';
import { shouldOpenNewPaymentProcessing } from '../selectors';

export default compose(
  withRouter,
  connect(state => ({
    shouldOpenNewPaymentProcessing: shouldOpenNewPaymentProcessing(state),
  })),
  withRole,
  withActiveType,
  withToggle('form'),
  withHandlers({
    addDebitCard: props => () => {
      if (props.shouldOpenNewPaymentProcessing) {
        let link = '/settings/bank-account/add/funds-destination';

        if (props.role === USER_TYPES.barber) {
          link = `/barber${link}`;
        }

        if (props.type === 'brand') {
          link = `/brand${link}`;
        }

        props.router.push(link);

        return;
      }

      props.formToggle();
    },
  })
);
